import React, { ReactNode, useState } from 'react';
import { FilterList } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';

import { FiltersContainer, VOFilters, VOFilterType } from '../../filters';

interface Props {
  fastFilterSlot: ReactNode;
  amountOfActiveFilters: number;
  onFiltersChanges: (filters: Partial<VOFilters>) => void;
}

export const FiltersSection = ({ amountOfActiveFilters, fastFilterSlot, onFiltersChanges }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Box sx={{ display: 'grid', gridTemplateColumns: '25rem 1fr', gap: '1rem' }}>
        <Box>{fastFilterSlot}</Box>

        <Stack direction="row" alignItems="center" gap="1rem" justifyContent="flex-end">
          <Button variant="text" startIcon={<FilterList />} onClick={() => setIsOpen(true)}>
            {`Filters ${amountOfActiveFilters ? `(${amountOfActiveFilters})` : ''}`}
          </Button>
        </Stack>
      </Box>

      <FiltersContainer
        open={isOpen}
        onChanged={onFiltersChanges}
        onClose={() => setIsOpen(false)}
        configuration={[VOFilterType.CLOSED_DEALS, VOFilterType.CREATE_DATE_RANGE]}
      />
    </>
  );
};
